<template lang="pug">
#task-logs.right-panel.md-elevation-3
    .md-layout-row
        .md-flex
            md-button.md-icon-button.md-dense(v-bind:to="{ name: 'Task', params: { projectid: this.$route.params.projectid, taskid: this.$route.params.taskid }, query: { search: $route.query.search, responsible_id: $route.query.responsible_id, responsible: $route.query.responsible } }"): md-icon arrow_back
    md-table(md-theme="white")
        md-table-row(v-for="log in logs" v-bind:key="log.id")
            md-table-cell
                .text(v-html="log.description")
            md-table-cell.time {{ log.created_at }}
</template>

<script>
import moment from "moment"
export default {
    created() {
        this.$store.commit('openRightPanel')
    },
    asyncComputed: {
        logs() {
            return this.$store.dispatch('logs/getLogs', {
                module_id: 8,
                entity_id: this.$route.params.taskid,
                entity_type: 'task'
            }).then(logs => {
                moment.locale('ru')
                logs.forEach(log => {
                    log.created_at = moment(log.created_at).format('D MMM YYYY HH:mm:ss')
                })
                return logs
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// TaskLogs.vue?5af2c016